import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-cream relative">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Contact Info */}
          <div>
            <span className="text-text-secondary font-medium tracking-widest uppercase text-sm mb-4 block">Get In Touch</span>
            <h2
              className="text-4xl md:text-5xl font-serif font-bold text-forest mb-8"
              style={{
                color: "#4f5a33"
              }}>Visit Our Clinic</h2>
            <p className="text-text-secondary text-lg font-light mb-10">
              Ready to start your journey to better health? Contact us today to schedule your appointment. 
              <br/><span className="font-medium text-forest mt-2 block">Se Habla Español.</span>
            </p>

            <div className="space-y-8">
              <div className="flex items-start gap-6">
                <div
                  className="bg-cream-alt p-4 rounded-full"
                  style={{
                    backgroundColor: "#4f5a33"
                  }}>
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="text-xl font-serif font-bold text-forest mb-2">Location</h4>
                  <p className="text-text-secondary font-light">4007 Magnolia Ave</p>
                  <p className="text-text-secondary font-light text-sm mt-1">Petaluma, CA 94952</p>
                </div>
              </div>

              <div className="flex items-start gap-6">
                <div
                  className="bg-cream-alt p-4 rounded-full"
                  style={{
                    backgroundColor: "#4f5a33"
                  }}>
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="text-xl font-serif font-bold text-forest mb-2">Phone</h4>
                  <p className="text-text-secondary font-light">(707) 494-0077</p>
                  <p className="text-text-secondary font-light text-sm mt-1">Call or Text</p>
                </div>
              </div>

              <div className="flex items-start gap-6">
                <div
                  className="bg-cream-alt p-4 rounded-full"
                  style={{
                    backgroundColor: "#4f5a33"
                  }}>
                  <Mail className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="text-xl font-serif font-bold text-forest mb-2">Email</h4>
                  <p className="text-text-secondary font-light">Huertachiro@huertachiropractic.com</p>
                </div>
              </div>

              <div className="flex items-start gap-6">
                <div
                  className="bg-cream-alt p-4 rounded-full"
                  style={{
                    backgroundColor: "#4f5a33"
                  }}>
                  <Clock className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="text-xl font-serif font-bold text-forest mb-2">Hours</h4>
                  <p className="text-text-secondary font-light">Mon - Fri: 9:00 AM - 6:00 PM</p>
                  <p className="text-text-secondary font-light">Sat: By Appointment</p>
                  <p className="text-text-secondary font-light">Sun: Closed</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-cream-alt p-8 md:p-12 rounded-sm shadow-lg">
            <h3
              className="text-2xl font-serif font-bold text-forest mb-6"
              style={{
                color: "#4f5a33"
              }}>Request an Appointment</h3>
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-text-secondary mb-2 uppercase tracking-wide">First Name</label>
                  <input type="text" className="w-full bg-cream border border-divider px-4 py-3 focus:outline-none focus:border-forest transition-colors" placeholder="Jane" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-text-secondary mb-2 uppercase tracking-wide">Last Name</label>
                  <input type="text" className="w-full bg-cream border border-divider px-4 py-3 focus:outline-none focus:border-forest transition-colors" placeholder="Doe" />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2 uppercase tracking-wide">Email</label>
                <input type="email" className="w-full bg-cream border border-divider px-4 py-3 focus:outline-none focus:border-forest transition-colors" placeholder="jane@example.com" />
              </div>

              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2 uppercase tracking-wide">Phone</label>
                <input type="tel" className="w-full bg-cream border border-divider px-4 py-3 focus:outline-none focus:border-forest transition-colors" placeholder="(555) 123-4567" />
              </div>

              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2 uppercase tracking-wide">Message</label>
                <textarea rows={4} className="w-full bg-cream border border-divider px-4 py-3 focus:outline-none focus:border-forest transition-colors" placeholder="Tell us about your pain or reason for visiting..."></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-forest text-cream py-4 font-medium uppercase tracking-wide hover:bg-forest-light transition-colors duration-300"
                style={{
                  backgroundColor: "#4f5a33"
                }}>
                Send Request
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
